module.exports = __webpack_public_path__ + "images/Pak Achmad.43bff3a2.png";